import { useEventBus } from "src/shared/eventbus/useEventBus.hooks";
import { useAuthenticationToken } from "src/authentication/hooks/useAuthenticationToken";
import { useMemo } from "react";
import { CHATS_EVENT_BUS_PATH } from "src/confs/APIConfig";
import type { ChatMessage } from "src/chats/objects/ChatMessage";

export const useChatMessagesControl = () => {
  const authenticationToken = useAuthenticationToken();
  const eventBusAddress = `${CHATS_EVENT_BUS_PATH}/bus`;
  const eventBusHandlers = useMemo<string[]>(() => {
    if (!authenticationToken.isChat) {
      return [];
    }
    if (authenticationToken.merchantGroupUUID) {
      return [
        `notifications.chat.merchant-group.${authenticationToken.merchantGroupUUID}`,
      ];
    } else if (authenticationToken.merchantUUID) {
      return [
        `notifications.chat.merchant.${authenticationToken.merchantUUID}`,
      ];
    } else {
      return ["notifications.chat.admin"];
    }
  }, [authenticationToken]);
  return useEventBus<ChatMessage>(
    eventBusAddress,
    eventBusHandlers,
    useMemo(
      () => ({ authToken: authenticationToken.authenticationToken }),
      [authenticationToken.authenticationToken],
    ),
  );
};
